import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  TOOTH_MOVEMENT_RESTRICTION,
  TOOTH_MOVEMENT_RESTRICTION_OPTIONS
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import DentitionTypeWithToothCharts from './DentitionTypeWithToothCharts/DentitionTypeWithToothCharts';
import { FormLabel } from './FormLabel/FormLabel';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';
interface Props {
  fieldName: string;
  title: string;
  animateLabel: string;
  isDisabled?: boolean;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
  isToothChartRestricted?: boolean;
}
const ToothMovementRestriction: FC<Props> = ({
  fieldName,
  title,
  isDisabled,
  animateLabel,
  isUpperDisabled,
  isLowerDisabled,
  isToothChartRestricted
}) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();

  const watchRestrictionSelection = watch(`${fieldName}.restriction`);
  const restrictedAdultToothChartValue = watch(
    fieldName.replace(/\.toothMovementRestriction$/, '.toothInformation') +
      '.toothChart'
  );
  const restrictedPrimaryToothChartValue = watch(
    fieldName.replace(/\.toothMovementRestriction$/, '.toothInformation') +
      '.primaryToothChart'
  );
  const fieldError = _.get(errors, `${fieldName}`);
  return (
    <div className='flex flex-col'>
      <FormLabel
        label={translate(title)}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={animateLabel}
      />
      <div>
        <RhfRadioGroup
          inputProps={{ disabled: isDisabled }}
          options={TOOTH_MOVEMENT_RESTRICTION_OPTIONS}
          name={`${fieldName}.restriction`}
          className='flex flex-row space-x-16'
          radioClassName='border-RADIO_BORDER'
          radioItemFont='md:text-17px text-sm '
        />
      </div>

      {watchRestrictionSelection ===
        TOOTH_MOVEMENT_RESTRICTION.SELECT_TEETH_SHOULD_NOT_BE_MOVED && (
        <div className='my-6 ml-5'>
          <DentitionTypeWithToothCharts
            dentitionSelectionName={`${fieldName}.dentitionSelection`}
            adultChartName={`${fieldName}.toothChart`}
            primaryChartName={`${fieldName}.primaryToothChart`}
            disabled={isDisabled}
            isUpperDisabled={isUpperDisabled}
            isLowerDisabled={isLowerDisabled}
            isToothChartRestricted={isToothChartRestricted}
            restrictedAdultToothChartValue={restrictedAdultToothChartValue}
            restrictedPrimaryToothChartValue={restrictedPrimaryToothChartValue}
          />
        </div>
      )}
    </div>
  );
};
export default ToothMovementRestriction;
